import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import ImageUploading from "react-images-uploading";
import { toast } from "react-toastify";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import {
  addIngredient,
  uploadImage,
} from "../../../redux/reducers/postApiSlice";
import { selectAuth } from "../../auth/auth.selector";
import { updateIngredient } from "../../../redux/reducers/putApiSlice";

const IngForm = ({ name, rowData, closeModal, callFunction }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const maxNumber = 1;
  const ingInitials = [];
  const [ingredientsArray, setIngredientsArray] = useState([ingInitials]);
  const iniIngForm = {
    ingName: name === "edit" && rowData?.name ? rowData.name : "",
    isActive: name === "edit" && rowData?.status === "active" ? true : false,
    ingImg:
      name === "edit" && rowData?.image ? [{ data_url: rowData.image }] : [],
  };
  const [ingForm, setIngForm] = useState(iniIngForm);
  const [ingFormErrors, setIngFormErrors] = useState();
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e, index, tagname) => {
    const { name, value, checked } = e.target;

    setIngredientsArray((prevIngredients) => {
      const updatedIngredients = [...prevIngredients];
      updatedIngredients[index] = {
        ...updatedIngredients[index],
        [name]: tagname === "check" ? checked : value,
      };
      return updatedIngredients;
    });
  };

  const onChangeImages = (imageList, index) => {
    setIngredientsArray((prevIngredients) =>
      prevIngredients.map((ingForm, i) =>
        i === index ? { ...ingForm, ingImg: imageList } : ingForm
      )
    );

    if (imageList.length > 0) {
      imageList.forEach(async (image) => {
        const blob = await fetch(image?.data_url).then((res) => res.blob());
        const file = new File([blob], "filename.jpeg", { type: "image/jpeg" });

        handleUploadImage(file, decryptedText?.token, index);
      });
    }

    setIsSubmit(false);
  };

  const onChangeEditInput = (e, tagname) => {
    setIsSubmit(false);
    const { name, value, checked } = e.target;
    setIngForm((prevs) => ({
      ...prevs,
      [name]: tagname === "check" ? checked : value,
    }));
  };

  const onChangeEditImages = (imageList, name) => {
    setIsSubmit(false);
    setIngForm((prevImages) => ({
      ...prevImages,
      [name]: imageList,
    }));

    if (imageList.length > 0) {
      imageList.forEach(async (image) => {
        const blob = await fetch(image?.data_url).then((res) => res.blob());
        const file = new File([blob], "filename.jpeg", { type: "image/jpeg" });

        handleUploadImage(file, decryptedText?.token);
      });
    }
  };

  const addMoreIngredient = () => {
    setIngredientsArray((prevIngredients) => [...prevIngredients, ingInitials]);
  };

  const removeIngredient = (index) => {
    setIngredientsArray((prevIngredients) =>
      prevIngredients.filter((_, i) => i !== index)
    );
  };

  const handleUploadImage = async (file, TOKEN, index) => {
    setIsSubmit(false);
    try {
      const actionResult = dispatch(uploadImage({ file, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        if (name === "edit") {
          setIngForm((prevs) => ({
            ...prevs,
            imgUrl: result?.payload?.image_url || "",
          }));
        } else {
          setIngredientsArray((prevIngredients) => {
            const updatedIngredients = [...prevIngredients];
            const updatedIngredient = { ...updatedIngredients[index] };

            updatedIngredient.imgUrl = result?.payload?.image_url || "";

            updatedIngredients[index] = updatedIngredient;
            return updatedIngredients;
          });
        }
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleCreateNewMeal ERROR => ", error);
    }
  };

  const handleAddIngredient = async (requestBody, TOKEN) => {
    setIsSubmit(false);

    try {
      const actionResult =
        name === "edit"
          ? dispatch(updateIngredient({ requestBody, filters: "", TOKEN }))
          : dispatch(addIngredient({ requestBody, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setIngredientsArray([ingInitials]);
        setIngForm(iniIngForm);
        setIngFormErrors();
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleAddIngredient ERROR => ", error);
    }
  };

  const handleSubmit = () => {
    const errors =
      name === "edit"
        ? validateEditForm(ingForm)
        : validateForm(ingredientsArray);
    setIngFormErrors(name === "edit" ? errors : { ingredients: errors });
    setIsSubmit(true);
  };

  const validateForm = (ingredientsArray) => {
    let errors = [];

    ingredientsArray.forEach((ingredient, index) => {
      let ingredientErrors = {};

      if (!ingredient?.ingName) {
        ingredientErrors.ingName = `Ingredient ${index + 1}: Name is required!`;
      }

      if (!ingredient?.ingImg || ingredient?.ingImg.length === 0) {
        ingredientErrors.ingImg = `Ingredient ${index + 1}: Image is required!`;
      }

      if (Object.keys(ingredientErrors).length > 0) {
        errors.push(ingredientErrors);
      }
    });

    return errors;
  };

  const validateEditForm = (ingForm) => {
    let errors = {};

    if (!ingForm?.ingName) {
      errors.ingName = `Ingredient Name is required!`;
    }

    if (!ingForm?.ingImg || ingForm?.ingImg.length === 0) {
      errors.ingImg = `Ingredient Image is required!`;
    }
    return errors;
  };

  const transformIngredientsArray = (ingredientsArray) => {
    return ingredientsArray.map((ingredient) => {
      return {
        name: ingredient.ingName,
        image: ingredient?.imgUrl ? ingredient.imgUrl : "",
        status: ingredient.isActive ? "active" : "inactive",
      };
    });
  };

  useEffect(() => {
    if (
      isSubmit &&
      Object.keys(name === "edit" ? ingFormErrors : ingFormErrors?.ingredients)
        ?.length === 0
    ) {
      if (name === "edit") {
        const requestBody = {
          uid: rowData?.uid,
          name: ingForm.ingName,
          image: ingForm?.imgUrl ? ingForm.imgUrl : "",
          status: ingForm.isActive ? "active" : "inactive",
        };
        handleAddIngredient(requestBody, decryptedText?.token);
      } else {
        const transformedData = transformIngredientsArray(ingredientsArray);
        const requestBody = {
          bulk_ingredient_data: transformedData,
        };
        handleAddIngredient(requestBody, decryptedText?.token);
      }
    }
  }, [isSubmit, ingFormErrors]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <div className="createNewCTOModalContainer mealsModalContainer addIngModal">
      <ModalHeadAndClose
        title={`${name === "edit" ? "Edit" : "Add"} Ingredient`}
        onClose={closeModal}
      />
      <div className="grayLine"></div>

      <form className="formContainer">
        {name !== "edit" ? (
          <>
            {ingredientsArray.map((ingForm, index) => (
              <div key={index} className="formInputsGrid twoGridSystem">
                <div className="formInputBox span2">
                  <label htmlFor="ingName" className={`formInputLabel`}>
                    Add Ingredients *
                  </label>

                  <input
                    type="text"
                    placeholder="Enter Ingredient Name"
                    className={`formInput ${
                      ingFormErrors?.ingredients?.[index]?.ingName
                        ? "formError"
                        : ""
                    }`}
                    name="ingName"
                    value={ingredientsArray[index].ingName || ""}
                    onChange={(e) => onChangeInput(e, index)}
                  />
                </div>

                <div className="formInputBox formInputUploadBox">
                  <label htmlFor={`ingImg-${index}`} className="formInputLabel">
                    Upload icon image *
                  </label>

                  <div
                    className={`commonWrapper commonUploadWrapper no-border ${
                      ingFormErrors?.ingredients?.[index]?.ingImg
                        ? "formError"
                        : ""
                    }`}
                  >
                    <div className="icon-upload-btn createIncentiveCategoryForImageUpload">
                      <div className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="49"
                          height="49"
                          viewBox="0 0 49 49"
                          fill="none"
                        >
                          <path
                            d="M35.2188 24.9431C34.3574 24.0828 33.1898 23.5996 31.9725 23.5996C30.7552 23.5996 29.5876 24.0828 28.7262 24.9431L10.7188 42.874C13.3066 42.874 21.1006 42.874 38.2812 42.874C39.8253 42.8683 41.3316 42.3958 42.6023 41.5186C43.873 40.6414 44.8488 39.4004 45.4016 37.9587C45.4016 37.7749 45.5394 37.5759 45.6006 37.3768L45.7844 36.749C45.8349 36.5064 45.8707 36.2609 45.8916 36.014C45.8985 35.9478 45.8985 35.8811 45.8916 35.8149C45.8978 35.7846 45.8978 35.7534 45.8916 35.7231L35.2188 24.9431Z"
                            fill="#A5A5A5"
                          />
                          <path
                            d="M45.9355 13.0463C45.7522 11.1457 44.8653 9.38218 43.4489 8.10171C42.0324 6.82125 40.1886 6.11626 38.2792 6.12508H10.7167C8.8073 6.11626 6.96351 6.82125 5.54706 8.10171C4.13061 9.38218 3.24375 11.1457 3.06046 13.0463C3.04235 13.291 3.04235 13.5367 3.06046 13.7813V35.2188C3.04567 35.484 3.04567 35.7499 3.06046 36.0151C3.09821 36.2728 3.14932 36.5283 3.21359 36.7807C3.7609 38.4437 4.70723 39.9473 5.96984 41.1601C6.36281 41.4953 6.80095 41.7737 7.2714 41.987L26.5192 22.7545C27.2304 22.0415 28.0753 21.4758 29.0054 21.0898C29.9356 20.7038 30.9328 20.5051 31.9398 20.5051C32.9469 20.5051 33.9441 20.7038 34.8742 21.0898C35.8044 21.4758 36.6493 22.0415 37.3605 22.7545L45.9355 31.3295V13.7813C45.9536 13.5367 45.9536 13.291 45.9355 13.0463ZM12.248 18.3751C11.6423 18.3751 11.0502 18.1955 10.5465 17.859C10.0429 17.5224 9.65037 17.0441 9.41858 16.4845C9.18679 15.925 9.12614 15.3092 9.24431 14.7151C9.36247 14.1211 9.65415 13.5754 10.0824 13.1471C10.5107 12.7188 11.0564 12.4271 11.6505 12.3089C12.2446 12.1908 12.8603 12.2514 13.4199 12.4832C13.9795 12.715 14.4578 13.1075 14.7943 13.6111C15.1308 14.1148 15.3105 14.7069 15.3105 15.3126C15.3105 16.1248 14.9878 16.9038 14.4135 17.4781C13.8391 18.0524 13.0602 18.3751 12.248 18.3751Z"
                            fill="#A5A5A5"
                          />
                        </svg>
                      </div>
                      <div className="image">
                        <ImageUploading
                          multiple
                          // value={ingredientsArray[index][0]?.ingImg || []}
                          value={
                            rowData?.image
                              ? rowData.image
                              : ingredientsArray[index].ingImg
                          }
                          onChange={(imageList) =>
                            onChangeImages(imageList, index)
                          }
                          maxNumber={maxNumber}
                          dataURLKey="data_url"
                        >
                          {({
                            imageList,
                            onImageUpload,
                            onImageRemoveAll,
                            onImageUpdate,
                            onImageRemove,
                            isDragging,
                            dragProps,
                          }) => (
                            <div className="upload__image-wrapper">
                              {imageList.length === 0 ? (
                                <>
                                  <button
                                    type="button"
                                    style={
                                      isDragging ? { color: "red" } : undefined
                                    }
                                    onClick={onImageUpload}
                                    {...dragProps}
                                  >
                                    Upload
                                  </button>
                                  &nbsp;
                                </>
                              ) : (
                                <>
                                  {imageList.map((image, imgIndex) => (
                                    <div key={imgIndex} className="image-item">
                                      <img
                                        src={image["data_url"]}
                                        alt=""
                                        width="100"
                                      />
                                      <div className="image-item__btn-wrapper">
                                        <button
                                          type="button"
                                          onClick={() =>
                                            onImageUpdate(imgIndex)
                                          }
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-cloud-plus"
                                            viewBox="0 0 16 16"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"
                                            />
                                            <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                          </svg>
                                        </button>
                                        <button
                                          type="button"
                                          onClick={() =>
                                            onImageRemove(imgIndex)
                                          }
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-x"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                </>
                              )}
                            </div>
                          )}
                        </ImageUploading>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="formInputBox formInputSwitchAddMore">
                  <div
                    className={`commonWrapper commonSwitchWrapper no-border`}
                  >
                    <Form.Check
                      type="switch"
                      name="isActive"
                      label={`${
                        ingForm.isActive ? "Active" : "Inactive for now"
                      }`}
                      // checked={ingForm.isActive}
                      checked={ingredientsArray[index].isActive}
                      onChange={(e) => onChangeInput(e, index, "check")}
                    />
                  </div>

                  <div className="extraBtnWrapper">
                    {index === ingredientsArray.length - 1 ? (
                      <button
                        type="button"
                        className="btn btn-dark extraBtn"
                        onClick={addMoreIngredient}
                      >
                        + Add more
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-danger extraBtn"
                        onClick={() => removeIngredient(index)}
                      >
                        Remove
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <>
            <div className="formInputsGrid">
              <div className="formInputBox span2">
                <label htmlFor="ingName" className={`formInputLabel `}>
                  Add Ingridients *
                </label>

                <input
                  type="text"
                  placeholder="Enter Ingridient Name"
                  className={`formInput ${
                    ingFormErrors?.ingName ? "formError" : ""
                  }`}
                  name="ingName"
                  value={ingForm.ingName}
                  onChange={(e) => onChangeEditInput(e)}
                />
              </div>

              <div className="formInputBox formInputUploadBox">
                <label htmlFor="ingImg" className="formInputLabel">
                  Upload icon image *
                </label>

                <div
                  className={`commonWrapper commonUploadWrapper ${
                    ingFormErrors?.ingImg && "formError"
                  }`}
                >
                  <div className="icon-upload-btn createIncentiveCategoryForImageUpload">
                    <div className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="49"
                        height="49"
                        viewBox="0 0 49 49"
                        fill="none"
                      >
                        <path
                          d="M35.2188 24.9431C34.3574 24.0828 33.1898 23.5996 31.9725 23.5996C30.7552 23.5996 29.5876 24.0828 28.7262 24.9431L10.7188 42.874C13.3066 42.874 21.1006 42.874 38.2812 42.874C39.8253 42.8683 41.3316 42.3958 42.6023 41.5186C43.873 40.6414 44.8488 39.4004 45.4016 37.9587C45.4016 37.7749 45.5394 37.5759 45.6006 37.3768L45.7844 36.749C45.8349 36.5064 45.8707 36.2609 45.8916 36.014C45.8985 35.9478 45.8985 35.8811 45.8916 35.8149C45.8978 35.7846 45.8978 35.7534 45.8916 35.7231L35.2188 24.9431Z"
                          fill="#A5A5A5"
                        />
                        <path
                          d="M45.9355 13.0463C45.7522 11.1457 44.8653 9.38218 43.4489 8.10171C42.0324 6.82125 40.1886 6.11626 38.2792 6.12508H10.7167C8.8073 6.11626 6.96351 6.82125 5.54706 8.10171C4.13061 9.38218 3.24375 11.1457 3.06046 13.0463C3.04235 13.291 3.04235 13.5367 3.06046 13.7813V35.2188C3.04567 35.484 3.04567 35.7499 3.06046 36.0151C3.09821 36.2728 3.14932 36.5283 3.21359 36.7807C3.7609 38.4437 4.70723 39.9473 5.96984 41.1601C6.36281 41.4953 6.80095 41.7737 7.2714 41.987L26.5192 22.7545C27.2304 22.0415 28.0753 21.4758 29.0054 21.0898C29.9356 20.7038 30.9328 20.5051 31.9398 20.5051C32.9469 20.5051 33.9441 20.7038 34.8742 21.0898C35.8044 21.4758 36.6493 22.0415 37.3605 22.7545L45.9355 31.3295V13.7813C45.9536 13.5367 45.9536 13.291 45.9355 13.0463ZM12.248 18.3751C11.6423 18.3751 11.0502 18.1955 10.5465 17.859C10.0429 17.5224 9.65037 17.0441 9.41858 16.4845C9.18679 15.925 9.12614 15.3092 9.24431 14.7151C9.36247 14.1211 9.65415 13.5754 10.0824 13.1471C10.5107 12.7188 11.0564 12.4271 11.6505 12.3089C12.2446 12.1908 12.8603 12.2514 13.4199 12.4832C13.9795 12.715 14.4578 13.1075 14.7943 13.6111C15.1308 14.1148 15.3105 14.7069 15.3105 15.3126C15.3105 16.1248 14.9878 16.9038 14.4135 17.4781C13.8391 18.0524 13.0602 18.3751 12.248 18.3751Z"
                          fill="#A5A5A5"
                        />
                      </svg>
                    </div>
                    <div className="image">
                      <ImageUploading
                        multiple
                        value={ingForm.ingImg}
                        onChange={(imageList, addUpdateIndex) =>
                          onChangeEditImages(imageList, "ingImg")
                        }
                        maxNumber={maxNumber}
                        dataURLKey="data_url"
                      >
                        {({
                          imageList,
                          onImageUpload,
                          onImageRemoveAll,
                          onImageUpdate,
                          onImageRemove,
                          isDragging,
                          dragProps,
                        }) => (
                          <div className="upload__image-wrapper">
                            {ingForm.ingImg?.length === 0 ? (
                              <>
                                <button
                                  type="button"
                                  style={
                                    isDragging ? { color: "red" } : undefined
                                  }
                                  onClick={onImageUpload}
                                  {...dragProps}
                                >
                                  Upload
                                </button>
                                &nbsp;
                              </>
                            ) : (
                              <>
                                {imageList.map((image, index) => (
                                  <div key={index} className="image-item">
                                    <img
                                      src={image["data_url"]}
                                      alt=""
                                      width="100"
                                    />
                                    <div className="image-item__btn-wrapper">
                                      <button
                                        type="button"
                                        onClick={() => onImageUpdate(index)}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-cloud-plus"
                                          viewBox="0 0 16 16"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"
                                          />
                                          <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                        </svg>
                                      </button>
                                      <button
                                        type="button"
                                        onClick={() => onImageRemove(index)}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          className="bi bi-x"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                        </svg>
                                      </button>
                                    </div>
                                  </div>
                                ))}
                              </>
                            )}
                          </div>
                        )}
                      </ImageUploading>
                    </div>
                  </div>
                </div>
              </div>

              <div className="formInputBox formInputSwitchAddMore">
                <div
                  className={`commonWrapper commonSwitchWrapper ${
                    ingFormErrors?.isActive && "formError"
                  }`}
                >
                  <Form.Check
                    type="switch"
                    name="isActive"
                    label={`${
                      ingForm.isActive ? "Active" : "Inactive for now"
                    }`}
                    checked={ingForm.isActive}
                    onChange={(e) => onChangeEditInput(e, "check")}
                  />
                </div>
              </div>
            </div>
          </>
        )}

        <div className="formButtons" style={{ justifyContent: "flex-end" }}>
          <Button className="saveBtn" variant="danger" onClick={handleSubmit}>
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default IngForm;
